export default __webpack_public_path__ + "static/media/tab-default.4eca17a1.svg";